<div style="text-align: center;">
  <button onclick="window.open('https://myprotection2.c1-alpha-tiscogroup.com/register/line/insure/completed?staus=fail', '_self');">Insure Complete open
  </button>
  <button onclick="window.location.href = 'https://myprotection2.c1-alpha-tiscogroup.com/register/line/insure/completed?staus=fail'">
      Insure Complete href
  </button>
  <!-- <button onclick="window.location.href = '/route2.html'">Route2</button> -->
  <!-- <button id="openWindowButton">callback</button> -->
  <!-- <h1>Call Back to My Protection</h1>
  <button onclick="alert('Test')">Alert!</button>
  <button onclick="window.location.href = 'https://tiscotest.herokuapp.com/index.html'">
      Click ME!
  </button>
  <button onclick="window.location.href = 'https://myprotection2.c1-alpha-tiscogroup.com/register/line/insure?appRef=1653923162-5MLx7A8V&connectRef=1653918597'">
      Insurance URL
  </button>
  <button onclick="window.location.href = 'https://liff.line.me/1653923162-5MLx7A8V/'">
      Insurance LIFF
  </button>
  <button onclick="window.location.href = 'https://parktical-liff.herokuapp.com/index.html'">
      Parktical URL
  </button>
  <button onclick="window.location.href = 'https://liff.line.me/1629220122-2DK56OgB'">
      Parktical LIFF
  </button> -->
</div>